import cn from 'classnames';
import React from 'react';
import sharedConfig from "@dataroom/config";
import DataroomsTable from '../DataroomsTable';
import { dataTableStyles, SortOrder } from '@dealroadshow/uikit-table/DataTable';
import Paginator from '@dealroadshow/uikit-paginator';
import styles from '../datarooms.module.scss';
import stylesForSet from '../../Set/set.module.scss';
import { ELEMENT_SCROLL_HEIGHT } from '../../common/constants';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import Column from '../../common/Column';
import DataroomAvailabilityContextProvider from '../../../contexts/DataroomAvailabilityContext';

interface IProps {
  tenant: DataroomTenant,
  collection: Array<any>,
  isFetching: boolean,
  totalCount: number,
  page: number,
  perPage: number,
  sortBy: string,
  sortOrder: SortOrder,
  sort: (sortBy: string, sortOrder: string) => void,
  paginate: (page: string | number) => any,
  setItemsPerPage: (perPage: | number) => any,
  columns: Array<Column>,
  scrollRef: React.RefObject<HTMLElement>,
  isExploreSetsTab: boolean,
}

function DataroomsList({
  collection,
  isFetching,
  totalCount,
  sortBy,
  sortOrder,
  page,
  perPage,
  isExploreSetsTab,
  tenant,
  columns,
  scrollRef,
  paginate,
  setItemsPerPage,
  sort,
}: IProps) {
  const handlePageChange = (page: { selected: number }) => {
    paginate(page.selected);
  };

  const handleItemsPerPageChange = (perPage: { value: number }) => {
    setItemsPerPage(perPage.value);
  };

  const isCollectionExist = collection && !!collection.length;
  const isSet = tenant === sharedConfig.investorset.code || tenant === sharedConfig.verisend.code
    || tenant === sharedConfig.researchroom.code;
  const tableStyles = isSet ? stylesForSet : styles;

  return (
    <>
      <DataroomAvailabilityContextProvider>
        <DataroomsTable
          tenant={ tenant }
          columns={ columns }
          className={ cn(
            dataTableStyles.isHoverable,
            tableStyles.dataroomTable,
            { [tableStyles.isEmpty]: !isCollectionExist },
          ) }
          collection={ collection }
          isFetching={ isFetching }
          onSortChange={ sort }
          sortBy={ sortBy }
          sortOrder={ sortOrder }
          isExploreSetsTab={ isExploreSetsTab }
        />
      </DataroomAvailabilityContextProvider>
      <Paginator
        className={ styles.dataRoomListPaginator }
        dataTest="dataRoomList"
        totalCount={ totalCount }
        page={ page }
        perPage={ perPage }
        onItemsPerPageChange={ handleItemsPerPageChange }
        onPageChange={ handlePageChange }
        scrollOnChange={ scrollRef }
        scrollOptions={ { offset: ELEMENT_SCROLL_HEIGHT } }
      />
    </>
  );
}

export default DataroomsList;
